import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    CardProps,
    Divider,
    Modal,
} from '@material-ui/core';
import { AddEditEvent } from './AddEditEvent';
import { useTranslation } from 'react-i18next';
import { Calendar as CalendarIcon } from 'react-feather';
import useAppointment from 'src/hooks/useAppointment';
import {
    completeAssistantAction,
    failAssistantAction,
    updateAssistantAction,
} from 'src/contexts/assistant/actionLifecycle';

/**
 * Represents the schedule appointment component
 *
 * @param {*} { className, ...rest }
 * @return {*}
 */
interface IScheduleAppointmentProps extends CardProps {
    openFromAssistant?: boolean;
    assistantRequestKey?: string;
}

export const ScheduleAppointment = ({
    openFromAssistant,
    assistantRequestKey,
    ...props
}: IScheduleAppointmentProps) => {
    const { t } = useTranslation();
    const { success, error, loading } = useAppointment();
    const [eventModal, setEventModal] = useState({
        open: false,
        event: null,
    });
    const handleEventNew = () => {
        setEventModal({
            open: true,
            event: null,
        });
    };

    useEffect(() => {
        if (openFromAssistant) {
            handleEventNew();
            updateAssistantAction(assistantRequestKey, {
                status: 'ready_to_confirm',
            });
        }
    }, [openFromAssistant, assistantRequestKey]);

    const handleModalClose = () => {
        setEventModal({
            open: false,
            event: null,
        });
    };

    const handleEventAdd = () =>
        setEventModal({
            open: false,
            event: null,
        });

    useEffect(() => {
        if (loading && assistantRequestKey)
            updateAssistantAction(assistantRequestKey, { status: 'executing' });
    }, [loading, assistantRequestKey]);

    useEffect(() => {
        if (success) {
            setEventModal({
                open: false,
                event: null,
            });
            if (assistantRequestKey)
                completeAssistantAction(assistantRequestKey);
        }
    }, [success, assistantRequestKey]);

    useEffect(() => {
        if (error && assistantRequestKey)
            failAssistantAction(assistantRequestKey, 'appointment_failed');
    }, [error, assistantRequestKey]);

    return (
        <Card {...props}>
            <Modal onClose={handleModalClose} open={eventModal.open}>
                <AddEditEvent
                    event={eventModal.event}
                    onAdd={handleEventAdd}
                    onCancel={handleModalClose}
                />
            </Modal>
            <CardHeader title={t('Leads.Appointment')} />
            <Divider />
            <CardContent>
                <Box mt={2}>
                    <Button
                        style={{ height: 60 }}
                        variant="contained"
                        type="submit"
                        size="large"
                        fullWidth
                        color="primary"
                        startIcon={<CalendarIcon />}
                        onClick={handleEventNew}
                    >
                        {t('BreadCumbs.Create2')} {t('Leads.Appointment')}
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
};
